// extracted by mini-css-extract-plugin
export default {"filterPanelContainer":"a2042b7cf625","filtersButton":"b7f878fefe89","plusIcon":"ab1496fb3112","addFilters":"de6d81d9e858"};